import { app } from '../../../../../../app';
import { Controller } from './remove-groups.controller';

app.component('companyUserDirectoriesDirectoryGroupsDirectoryRemoveGroups', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./remove-groups.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/remove-groups/remove-groups.component.js